import { gsap } from 'gsap';

export default class {
  constructor(character) {
    this.character = character;
    this.images = this.character.querySelectorAll('img');
    this.durationPerFrame = 0.5;
    this.initTimeline();
  }

  initTimeline() {
    this.tl = gsap.timeline({
      repeat: -1,
      repeatDelay: this.durationPerFrame,
      paused: true,
    });
  }

  move() {
    this.killPreviousTimeline();
    this.setInitialOpacity();
    this.createTimeline();
    this.tl.play();
  }

  killPreviousTimeline() {
    if (this.tl) {
      this.tl.kill();
      this.initTimeline();
    }
  }

  setInitialOpacity() {
    gsap.set(this.images, { opacity: 0 });
    gsap.set(this.images[0], { opacity: 1 });
  }

  createTimeline() {
    this.images.forEach((image, index, array) => {
      this.tl.set(image, { opacity: 0 }, index * this.durationPerFrame);
      this.tl.set(array[(index + 1) % array.length], { opacity: 1 }, index * this.durationPerFrame);
    });
  }
}
